import type { AxiosError } from "axios";

import { type ApiErrorType, getApiErrorType } from "@/utils/apiErrorType";

export type { ApiErrorType };

export type ApiErrorPayload = {
  message: string;
  errorType: ApiErrorType;
  status?: number;
  /** API がフィールド単位のバリデーションエラーを返した場合の対象フィールド名。 */
  field?: string;
  /** 安定したエラーコード (分岐・文言差し替え用)。 */
  code?: string;
};

export const normalizeDisplayApiErrorType = (
  errorType: ApiErrorType | null | undefined,
): ApiErrorType => errorType ?? "unknown";

const getErrorMessage = (error: unknown, fallbackMessage: string): string => {
  const maybeAxiosError = error as AxiosError<{ message?: string }>;
  const responseMessage = maybeAxiosError.response?.data?.message;
  if (typeof responseMessage === "string" && responseMessage.trim()) {
    return responseMessage;
  }

  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }

  return fallbackMessage;
};

export const toApiErrorPayload = (
  error: unknown,
  fallbackMessage = "Failed to fetch data",
): ApiErrorPayload => {
  const maybeAxiosError = error as
    | AxiosError<{
        field?: string;
        code?: string;
      }>
    | null
    | undefined;
  const data = maybeAxiosError?.response?.data;

  return {
    errorType: getApiErrorType(error),
    message: getErrorMessage(error, fallbackMessage),
    status: maybeAxiosError?.response?.status,
    field: typeof data?.field === "string" ? data.field : undefined,
    code: typeof data?.code === "string" ? data.code : undefined,
  };
};
